import { Observable } from 'rxjs';

export interface User {
  name: string;
  picture: string;
  email?: string;
  type?: boolean;
}

export interface Contacts {
  user: User;
  type: string;
}

export interface RecentUsers extends Contacts {
  time: number;
}

export abstract class NbUserData {
  abstract getUsers(): Observable<{ [key: string]: User }>;
  abstract getContacts(): Observable<Contacts[]>;
  abstract getRecentUsers(): Observable<RecentUsers[]>;
}
